import {
    DictType, ScenarioPublish,
    Scene, SceneTemplate, SimpleScene
} from ".";

export type ScenarioConstants = DictType<any>;

export interface Scenario {
    id: string;
    user_id: string;
    name: string;
    description: string;
    source?: string;
    base_template_id?: string;
    constants?: ScenarioConstants;
    publish?: ScenarioPublish;
    properties?: ScenarioProperties;
    faq?: FaqCategory[];
    created_at: string;
    updated_at: string;
    deleted_at?: string;
}

export interface FaqQna {
    question: string;
    answer: string;
}

export interface FaqCategory {
    category: string;
    qna_list: FaqQna[];
}

export interface MessageHistoryCustom {
    key: string;
    label: string;
}

export const DEFAULT_NLU_CLIENT = "42maru";
export interface ScenarioProperties {
    conversation_expire_seconds?: number;
    last_conversation_expire_seconds?: number;
    api_request_timeout?: number;
    analytics_exclude_scenes?: SimpleScene[];
    document_version?: string;
    welcome_scene_id?: number;
    welcome_scene_custom_id?: string;
    fallback_scene_id?: number;
    fallback_scene_custom_id?: string;
    enable_debug?: boolean;
    nlu_client?: string;
    nlu_agent?: string;
    coupling_agent_token?: string;
    ac_token?: string;
    enable_intent_selection?: boolean;
    intent_selection_property?: DictType<any>;
    enable_nlu_result_customize?: boolean;
    nlu_result_customize_code?: string;
    dialogflow_key_file?: string;
    error_message?: string;
    language?: string;
    ga_tracker_id?: string;
    ga_tracker_enabled?: boolean;
    webhook_url?: string;
    handover_bot_response_webhook_url?: string;
    login_user_analytics_custom?: string | any[];
    message_history_custom?: MessageHistoryCustom[];
    message_history_excel_custom?: string | any[];
    enable_restore_context?: boolean;
    context_exclude_keys?: string[];
}

export interface SimpleScenario {
    id: string;
    user_id: string;
    name: string;
    description: string;
    source?: string;
    created_at: string;
    updated_at: string;
}

export interface ScenarioOwner {
    user_id: string;
    nickname: string;
    email: string;
    given_name?: string;
    family_name?: string;
}

export interface OwnScenario extends SimpleScenario {
    owner: ScenarioOwner;
}

export interface ScenarioCreate {
    name: string;
    description: string;
}

export interface ScenarioUpdate {
    name?: string;
    description?: string;
    constants?: ScenarioConstants;
    publish?: DictType<any>;
    properties?: ScenarioProperties;
    faq?: FaqCategory[];
}

export interface Actor {
    user_id?: string;
    user_name?: string;
    name?: string;
    email?: string;
    ip_address?: string | DictType<any>;
}

export interface ScenarioSnapshot {
    scenario?: Scenario;
    scenes?: Scene[];
    templates?: SceneTemplate[];
}

